module.exports = __webpack_public_path__ + "static/media/new-narabahasa-logo.328af333.png";